




































































































































































































































































































import ActionBar from '@/components/action-bar/action-bar.vue';
import KendoChart from '@/components/kendo-chart/kendo-chart.vue';
import { DIRECT_SALES_ROUTES } from '@/modules/direct-sales/router';
import { numeralService, stringService, httpService } from '@/services';
import _ from 'lodash';
import moment from 'moment';
import { debounceTime, distinctUntilChanged, pluck, startWith } from 'rxjs/operators';
import { Component, Vue } from 'vue-property-decorator';
import { AxiosError, AxiosResponse } from 'axios';
import { CONFIG } from '@/config';
import PageLoader from '@/components/page-loader/page-loader.vue';
import KendoDropdown from '@/components/kendo-dropdown/kendo-dropdown.vue';

@Component({
  subscriptions() {
    return {
      searchValue$: this.$watchAsObservable('state.searchValue').pipe(
        pluck('newValue'),
        debounceTime(400),
        distinctUntilChanged(),
        startWith('')
      )
    };
  },
  components: {
    ActionBar,
    KendoChart,
    PageLoader,
    KendoDropdown
  }
})
export default class DirectSalesProposalsPage extends Vue {
  public getMax = numeralService.getMax;
  public getMin = numeralService.getMin;
  public searchValue$: string;

  public state: any = {
    data: [],
    searchValue: '',
    familyColumnOrder: 'dateProposal',
    storeSelected: 0,
    groupSelected: 0,
    familyStatus: 1,
    selectedSituation: 0,
    currentDate: moment()
      .startOf('month')
      .toDate(),
    favoritedOnly: false,
    proposalSelect: {},
    user: {},
    dateInitial: moment()
      .subtract(14, 'days')
      .format('DD/MM/YYYY'),
    dateFinal: moment().format('DD/MM/YYYY')
  };

  public openConfiramation: boolean = false;

  public openConfiramationRenewProposal: boolean = false;

  public familyColumnOrderDataSource = [
    {
      text: 'Data',
      value: 'dateProposal'
    },
    {
      text: 'Cliente',
      value: 'nameConsumer'
    },
    {
      text: 'Situação',
      value: 'orderSituation'
    },
    {
      text: 'Qtd Veículos',
      value: 'totalVehicles'
    }
  ];

  public familyStatusDataSource = [];

  public get proposalsList() {
    return (
      _(this.state.data)
        // Filter by family
        .filter((item: any) => {
          if (this.state.selectedSituation === 0) {
            return true;
          } else if (item.idSituation === this.state.selectedSituation) {
            return true;
          }
          return false;
        })
        // Filter by store
        .filter((item: any) => {
          if (this.state.storeSelected === 0) {
            return true;
          } else if (item.idStoreSale === this.state.storeSelected) {
            return true;
          }
          return false;
        })
        // Filter by group
        .filter((item: any) => {
          if (this.state.groupSelected === 0) {
            return true;
          } else if (item.idGroup === this.state.groupSelected) {
            return true;
          }
          return false;
        })
        .filter((item: any) =>
          _.size(this.searchValue$)
            ? _.some(['situation', 'nameConsumer', 'dateProposal'], p =>
                stringService.normalize(item[p]).includes(stringService.normalize(this.searchValue$))
              )
            : true
        )
        .orderBy((item: any) => {
          switch (this.state.familyColumnOrder) {
            case 'dateProposal':
              return -new Date(item.dateProposal);
            default:
              return item[this.state.familyColumnOrder];
          }
        })
        .value()
    );
  }

  public getColorSituation(idSituation: Number) {
    switch (idSituation) {
      case 1: {
        return '#529952';
      }
      case 2: {
        return '#D8A443';
      }
      case 3: {
        return '#DD3E3E';
      }
      case 4: {
        return 'grey';
      }
      case 5: {
        return '#387DAA ';
      }
      default: {
        return '#403f3f';
      }
    }
  }

  public get productSituation() {
    const status = _(this.state.data)
      .map((d: any) => ({ text: d.situation, value: d.idSituation, order: d.orderSituation }))
      .uniqBy('text')
      .orderBy('order')
      .value();
    return [{ text: 'SELECIONE', value: 0 }, ...status];
  }

  public get stores() {
    this.state.storeSelected = 0;

    const status = _(this.state.data)
      .filter((item: any) => {
        if (this.state.groupSelected === 0) {
          return true;
        } else if (item.idGroup === this.state.groupSelected) {
          return true;
        }
        return false;
      })
      .map((d: any) => ({ text: d.store, value: d.idStoreSale }))
      .uniqBy('text')
      .orderBy('value')
      .value();

    return status;
  }

  public get groups() {
    this.state.groupSelected = 0;

    const status = _(this.state.data)
      .filter((item: any) => {
        if (this.state.selectedSituation === 0) {
          return true;
        } else if (item.idSituation === this.state.selectedSituation) {
          return true;
        }
        return false;
      })
      .map((d: any) => ({ text: d.nameGroup, value: d.idGroup }))
      .uniqBy('text')
      .orderBy('value')
      .value();
    return status;
  }

  private changedStatus(proposal) {
    this.state.proposalSelect = proposal;
    this.openConfiramation = true;
  }

  private cancelModalConfirmation() {
    this.openConfiramation = false;
    this.openConfiramationRenewProposal = false;
  }

  private changedRenewProposal(proposal) {
    this.state.proposalSelect = proposal;
    this.openConfiramationRenewProposal = true;
  }

  private ConfirmModal() {
    let data: any = { id: this.state.proposalSelect.id, idSituation: this.state.proposalSelect.idSituation };

    httpService.http
      .put(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/situation/${this.state.proposalSelect.id}`, data)
      .then((res: AxiosResponse) => {
        this.state.proposalSelect = {};
        this.openConfiramation = false;
        this.getProposal();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  private RenewProposal() {
    httpService.http
      .post(
        `${CONFIG.URL.NEODASH_API}/api/directsales/proposal/renew/${this.state.proposalSelect.id}`,
        this.state.proposalSelect.id
      )
      .then((res: AxiosResponse) => {
        this.state.proposalSelect = {};
        this.openConfiramationRenewProposal = false;
        this.getProposal();
      });
  }

  public goToProposals() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS
    });
  }

  public goToProductHistory(id: number) {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.DASHBOARD
    });
  }

  public goToListClients() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.LIST_CLIENTS
    });
  }

  public goToCreateProposal() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS_CREATE
    });
  }

  public goToChart() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS_CREATE
    });
  }

  public goToProposal(data) {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS_COMPLETE,
      params: {
        consumerId: String(data.idConsumer),
        proposalId: String(data.id),
        showProgress: String(0)
      }
    });
  }

  public copyProposal(data) {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS_CREATE,
      params: {
        proposalId: String(data.id)
      }
    });
  }

  public getSituations() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/proposalSituations/`)
      .then((res: AxiosResponse) => {
        this.familyStatusDataSource = res.data;
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getUser() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/user`)
      .then((res: AxiosResponse) => {
        this.state.user = res.data;
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getProposal() {
    httpService.http
      .get(
        `${CONFIG.URL.NEODASH_API}/api/directsales/proposal/proposals/${this.FormataStringData(
          this.state.dateInitial
        )}/${this.FormataStringData(this.state.dateFinal)}/`
      )
      .then((res: AxiosResponse) => {
        this.state.data = _(res.data)
          .map(m => ({
            proposalVehicles: m.proposalVehicles,
            id: m.id,
            dateProposal: moment(m.dateProposal).format('DD/MM/YYYY'),
            deliveryIndicator: m.deliveryIndicator,
            situation: m.expired ? 'EXPIROU' : m.situation,
            orderSituation: m.expired ? 999 : m.orderSituation,
            store: m.storeName,
            expired: m.expired,
            proposalExpired: m.proposalExpired,
            idStoreSale: m.idStoreSale,
            nameConsumer: m.nameConsumer.trim(),
            nameGroup: m.nameGroup.trim(),
            idGroup: m.idGroup,
            numVersions: m.historicalProposal.length,
            families: _(m.proposalVehicles)
              .map((map: any) => ({ family: map.family }))
              .uniqBy((d: any) => d.family)
              .value(),
            idSituation: m.expired ? 100 : m.idSituation,
            idConsumer: m.idConsumer
          }))
          .value();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public FormataStringData(data: string) {
    let dia = data.split('/')[0];
    let mes = data.split('/')[1];
    let ano = data.split('/')[2];

    return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2);
  }

  public setDateInit(data) {
    this.state.dateInitial = data;
    this.getProposal();
  }

  public setDateFim(data) {
    this.state.dateFinal = data;
    this.getProposal();
  }

  public mounted() {
    this.getSituations();
    this.getProposal();
    this.getUser();
  }
}
